import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import lineBlack from "../../../themes/dubai/assets/images/icons/line-black.png";
import Slider from "react-slick";
import { id } from "date-fns/locale";
import rings from '../../../themes/dubai/assets/images/explore-collection-img/rings.png';
import earrings from '../../../themes/dubai/assets/images/explore-collection-img/earrings.png';
import bracelets from '../../../themes/dubai/assets/images/explore-collection-img/bracelets.png';
import necklace from '../../../themes/dubai/assets/images/explore-collection-img/necklace.png';
import pendants from '../../../themes/dubai/assets/images/explore-collection-img/pendants.png';
import anklets from '../../../themes/dubai/assets/images/explore-collection-img/anklets.png';
import leftArrow from "../../../themes/dubai/assets/images/icons/left-arrow.png";
import RightArrow from "../../../themes/dubai/assets/images/icons/right-arrow.png";

const ExploreCollection = () => {
  const exCollection = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows:true,
    prevArrow: <Image src={leftArrow} alt="arrow" />,
    nextArrow: <Image src={RightArrow} alt="arrow" />,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const exCollectionData = [
    {
      id: 1,
      title: "Rings",
      image: rings,
      link: "/ringsettings"
    },
    {
      id: 2,
      title: "Earrings",
      image: earrings,
      link: "/jewelry/earrings"
    },
    {
      id: 3,
      title: "Necklace",
      image: necklace,
      link: "/jewelry/necklaces"
    },
    {
      id: 4,
      title: "Bracelets",   
      image: bracelets,
      link: "/jewelry/bracelets"
    },
    {
      id: 5,
      title: "Pendants",
      image: pendants,
      link: "/jewelry/pendants"
    },
    // {
    //   id: 6,
    //   title: "Anklets",
    //   image: anklets,
    //   link: "/anklets"
    // },
  ]
  return (
    <section className="du_exCollection_section">
      <Container fluid className="dubai-showcase-container">
        <Heading>
          <h2>Explore our collection</h2>
          <Image src={lineBlack} alt="Black Image Line" className="img-fluid"/>
        </Heading>

        {/* <Row className="d-none">
          <Col md={3} xs={6}>
            <div className="item text-center">
              <Link to="/jewelry/fashion-rings" className="img-box">
                <Image src={`${ImageUrl}theme/showcase/Rings.webp`} alt="Ring" />
              </Link>
              <Link to="/jewelry/fashion-rings">Rings</Link>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div className="item text-center">
              <Link to="/jewelry/bracelets" className="img-box">
                <Image src={`${ImageUrl}theme/showcase/Bracelets.webp`} alt="Bracelet" />
              </Link>
              <Link to="/jewelry/bracelets">Bracelets</Link>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div className="item text-center">
              <Link to="/jewelry/earrings" className="img-box">
                <Image src={`${ImageUrl}theme/showcase/Earrings.webp`} alt="Earring" />
              </Link>
              <Link to="/jewelry/earrings">Earrings</Link>
            </div>
          </Col>
          <Col md={3} xs={6}>
            <div className="item text-center">
              <Link to="/jewelry/necklaces" className="img-box">
                <Image src={`${ImageUrl}theme/showcase/Necklaces.webp`} alt="Necklace" />
              </Link>
              <Link to="/jewelry/necklaces">Necklaces</Link>
            </div>
          </Col>
        </Row> */}
        <Row>
          <Col sm={12} md={12} lg={12}>
          <Slider {...exCollection} className="du_exCollection_slider">
        {exCollectionData.map((item, i) => (
          <div className="du_exCollection_slider_inner_box">
        <div className="item">
              <Link to={item.link} className="img-box">
                <Image src={item.image} alt={item.title} />
              </Link>
              <Link to={item.link} >{item.title}</Link>
            </div>
         </div>
        ))}
        
       
      </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ExploreCollection;
